const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0 clamp(1rem, 5vw, 5.6rem)',
    color: '#FFF',
    gap: '1rem',
    top: "clamp(3rem, 5vh, 2rem)",
    // backgroundColor: 'red',
    margin: 0,
  },
  
  header: {
    display: 'flex',
    justifyContent: 'center', // 🔹 Centraliza horizontalmente
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    padding: 'clamp(1rem, 4vw, 2rem) 0', // 🔹 Espaçamento vertical responsivo (substitui marginBottom)
  },
  
  title: {
    fontSize: 'clamp(2rem, 4vw, 3.12rem)',
    fontFamily: 'Orbitron, sans-serif',
    textAlign: 'center', // 🔹 Garante alinhamento do texto no centro, mesmo em telas menores
    margin: 0, // 🔹 Remove margens padrão do h2
  },
  largeCardContainer: {
    position: 'relative',
    width: 'fit-content', // <-- permite centralizar com margin auto
    maxWidth: '90vw',
    height: 'auto',
    marginTop: 'clamp(2rem, 5vw, 4rem)',
    marginLeft: 'auto',   // <-- centraliza horizontalmente
    marginRight: 'auto',  // <-- idem
  },
  
  largeCardWrapper: {
    position: 'relative',
    width: 'clamp(12rem, 90vw, 30rem)',
    height: 'clamp(20rem, 50vh, 16rem)',
    overflow: 'hidden',
    border: "0.8px solid rgba(200, 200, 200, 0.4)",
    borderRadius: '0 0 50px 50px',
    marginTop: 'clamp(-2rem, 4vw, -2rem)',
  },
  
  largeCardContent: {
    position: 'relative',
    zIndex: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 'clamp(1rem, 4vw, 2.2rem) clamp(2rem, 5vw, 4rem)',
  },
  largeCardTitle: {
    fontSize: 'clamp(1rem, 2vw, 1.5rem)',
    color: '#D9D9D9',
    marginTop: '0',
    marginBottom: 'clamp(0.8rem, 2vw, 1.5rem)',
  },
  largeCardText: {
    lineHeight: '1.6',
    color: 'rgba(217, 217, 217, 0.7)',
    marginTop: '0',
    marginBottom: '0',
  },
  verticalBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '2px',
    width: '100%',
    backgroundColor: '#D9D9D9',
    opacity: 0.8,
    zIndex: 5,
  },
  cardImage: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 2,
  },
  cardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(80px)',
    zIndex: 3,
  },
  cardBlurHover: {
    animation: 'blurAnimation 4s infinite ease-in-out',
  },
  cardsWrapper: {
    display: 'flex',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    WebkitOverflowScrolling: 'touch',
    gap: 'clamp(1.4rem, 4vw, 1.5rem)',
    padding: 'clamp(1rem, 4vw, 1.5rem) 0',
    width: '100%',
    // background: 'blue',
    // marginTop: 'clamp(2rem, 5vw, 4rem)',
  },  
  cardOuterBorder: {
    scrollSnapAlign: 'center',
    flexShrink: 0,
    padding: 'clamp(0.2rem, 0.3vw, 0.8rem)', // ✅ esse padding cria o "respiro" interno
    width: 'calc(clamp(18rem, 30vw, 25rem) + 1px)',
    // minHeight: 'clamp(10rem, 20vw, 15.65rem) + 2px)',
    height: 'clamp(12rem, 20vw, 15.65rem)',
    borderRadius: '25px',
    // background:
    //   'linear-gradient(to bottom left, rgba(217, 217, 217, 0.4) 0%, rgba(217, 217, 217, 0.1) 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },  
  card: {
    position: 'relative',
    width: 'clamp(20rem, 20vw, 20rem)',
    // minHeight: 'clamp(10rem, 20vw, 15.65rem)',
    height: 'clamp(12rem, 20vw, 15.65rem)',
    border: "1px solid rgba(200, 200, 200, 0.4)",
    borderRadius: '25px',
    overflow: 'hidden',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    zIndex: 2,
  },
  cardContent: {
    position: 'relative',
    zIndex: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 'clamp(1rem, 3vw, 1.5rem)',
  },
  cardIcon: {
    width: 'clamp(1.5rem, 3vw, 2rem)',
    height: 'auto',
    marginBottom: 'clamp(1rem, 5vw, 3rem)',
  },
  cardTitle: {
    fontSize: 'clamp(1.2rem, 3vw, 2rem)',
    fontWeight: '400',
    fontFamily: 'Orbitron, sans-serif',
    marginBottom: 'clamp(0.5rem, 2vw, 1rem)',
    marginTop: '0',
  },
  cardText: {
    fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    opacity: 0.5,
    marginTop: '0',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
  },  
};

export default styles;
